import messageEnums from 'enums/messages';
import sessionEvents from 'events/session';
import { hasActiveSession } from 'app/modules';
import userSelectors from 'selectors/user';

export default function updateCustomerUrl(customerUrl) {
  return (dispatch, getState, { messageGateway }) => {
    // TODO: remove
    // this is a hack. This function shouldnt be called unless there is already an active session
    if (!hasActiveSession(getState())) {
      return;
    }
    const state = getState();
    const text = 'URL_NAVIGATED';
    const type = 'text';
    const metadata = {
      gladlyCustomerId: userSelectors.getGladlyCustomerId(state.user),
      subType: messageEnums.SUB_TYPES.URL,
      url: customerUrl,
    };

    dispatch(sessionEvents.updateSessionUrl(customerUrl));
    messageGateway.updateCustomerUrl(metadata, text, type);
  };
}
